export function createImageThumbnail(file: Blob, size: number = 64): Promise<string> {
    if (file instanceof File) {
        if (file.type.startsWith('image/svg')) {
            return readFileAsDataURL(file);
        }
    }
    return new Promise<string>((resolve) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext("2d");
        if (context) {
            const reader = new FileReader();
            reader.onload = () => {
                const img = new Image();
                img.onload = () => {
                    let targetWidth = size;
                    let targetHeight = size;
                    if (img.width > img.height) {
                        targetHeight = size * img.height / img.width;
                    } else {
                        targetWidth = size * img.width / img.height;
                    }
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    context.drawImage(img, 0, 0, img.width, img.height, 0, 0, targetWidth, targetHeight);

                    resolve(canvas.toDataURL());
                }
                img.src = reader.result as string;
            };
            reader.onerror = event => console.error("Unable to read image data", event);
            reader.readAsDataURL(file);
        }
    });
}

export function readFileData(file: Blob): Promise<string> {
    return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
            const stringResult = reader.result as string;
            const fixedResult = stringResult.slice(stringResult.indexOf("base64,") + 7);
            resolve(fixedResult);
        };
        reader.onerror = event => console.error("Unable to read file data", event);
        reader.readAsDataURL(file);
    });
}

export function readFileDataAsText(file: Blob): Promise<string> {
    return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = event => console.error("Unable to read file data", event);
        reader.readAsText(file);
    });
}

export function readFileAsDataURL(file: Blob): Promise<string> {
    return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
            const stringResult = reader.result as string;
            resolve(stringResult);
        };
        reader.onerror = event => console.error("Unable to read file data", event);
        reader.readAsDataURL(file);
    });
}
